module.exports = __webpack_public_path__ + "static/media/mice.206708ef.svg";